import { toE164Phone } from "@shared/profileInputs";

export function normalizeGuestEmail(value: string) {
  return value.trim().toLowerCase();
}

export function validGuestEmail(value: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizeGuestEmail(value));
}

/** US display mask. Keep excess digits visible so pasted overlong numbers cannot be truncated silently. */
export function formatGuestPhone(value: string) {
  const digits = value.replace(/\D/g, "");
  if (digits.length > 11 || (digits.length === 11 && !digits.startsWith("1"))) return digits;
  const national = digits.length === 11 ? digits.slice(1) : digits;
  if (!national) return "";
  if (national.length < 4) return `(${national}`;
  if (national.length < 7) return `(${national.slice(0, 3)}) ${national.slice(3)}`;
  return `(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6)}`;
}

export function normalizeGuestPhone(value: string) {
  return toE164Phone(value);
}

export function isGuestPurchaseVerified(input: {
  guestCodeVerified: boolean;
  profileValid: boolean;
  emailRecognition: string;
}) {
  return input.guestCodeVerified && input.profileValid && input.emailRecognition === "guest";
}

export function guestProfileErrors(profile: { name: string; email: string; companyName: string; jobTitle: string; phone: string }) {
  return {
    name: profile.name.trim() ? "" : "Full name is required.",
    email: validGuestEmail(profile.email) ? "" : "Enter a valid email address.",
    companyName: profile.companyName.trim() ? "" : "Company name is required.",
    jobTitle: profile.jobTitle.trim() ? "" : "Job title is required.",
    phone: normalizeGuestPhone(profile.phone) ? "" : "Enter a complete 10-digit US phone number.",
  };
}
